import React from 'react';
import '../Dashboard/DashboardPage.css'; // Use CSS from Dashboard

const NotFoundPage = () => {
    return (
        <div className="dashboard">
            <div className="content">
                <h3>404 - Page Not Found</h3>
                <div className="dashboard-message">
                    <p>Oops! The page you're looking for doesn't exist.</p>
                    <p>Perhaps you followed a broken link or typed the URL incorrectly.</p>
                    <p>Let's get you back on track.</p>
                </div>

                <div className="dashboard-container">
                    <div className="dashboard-widget">
                        <div className="widget-title">Useful Links</div>
                        <div className="widget-content">
                            <ul className="nav-menu">
                                <li><a href="/">Home</a></li>
                                <li><a href="/about">About Us</a></li>
                                <li><a href="/contact">Contact</a></li>
                                <li><a href="/help">Help</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default NotFoundPage;